import type { ReactElement } from "react"

interface DisplayProps {
  from: string
  children: ReactElement
  to?: string | null
  fallbackChildren?: ReactElement
}

function Display({
  to,
  from,
  children,
  fallbackChildren,
}: DisplayProps): ReactElement<DisplayProps> | null {
  const currentDate = Date.now()

  if (
    (to && Date.parse(from) <= currentDate && currentDate <= Date.parse(to)) ||
    (!to && Date.parse(from) <= currentDate)
  ) {
    return children
  }

  return fallbackChildren ?? null
}

export default Display
